export default __webpack_public_path__ + "fonts/solution-img3.svg";